import { AfterViewInit, ChangeDetectorRef, EventEmitter, QueryList } from '@angular/core';
import { merge } from 'rxjs';
import { FilterComponentBase, FilterKeys } from '../filters/filters';
import { FuelFilter } from '../filters/airport-filters';
import { FuelType } from '../../business/models/business-fuel.model';
import { SearchQuery } from '../models/search-query.model';
import { GlobalSettingsService } from '../../shared/services/global-settings.service';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';
var FuelFilterListComponent = /** @class */ (function () {
    function FuelFilterListComponent(_cdRef, _globalSettingsService, _analyticsService) {
        this._cdRef = _cdRef;
        this._globalSettingsService = _globalSettingsService;
        this._analyticsService = _analyticsService;
        this.filtersChange = new EventEmitter();
        this.numSelectedChange = new EventEmitter();
        this.publicUseChanged = new EventEmitter();
        this.FilterKeys = FilterKeys;
        this.prevNumSelected = null;
        this.fuelType = FuelType._100LL;
    }
    FuelFilterListComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        merge.apply(void 0, this.filterComponents.map(function (f) { return f.change.asObservable(); })).subscribe(function () {
            _this.filtersChange.emit();
            _this.updateNumSelected();
        });
        this.filterComponents.filter(function (c) { return c.filter.enabled; }).forEach(function (filt) {
            if (filt.filter.key !== FilterKeys.PublicUse) {
                filt.filter.enabled = false;
            }
        });
        setTimeout(function () {
            _this.fuel100LLFilter.enabled = true;
            _this._globalSettingsService.changeFuelType('100LL');
            _this.updateNumSelected();
            _this.filtersChange.emit();
        }, 300);
        this._analyticsService.pageView('airport_landingpage_fuel', 'Fuel Price Map Landing Page filters');
    };
    FuelFilterListComponent.prototype.onPublicUseChanged = function () {
        this.publicUseChanged.emit(this.query.getFilter(FilterKeys.PublicUse).enabled);
    };
    FuelFilterListComponent.prototype.updateNumSelected = function () {
        var numSelected = this.getNumSelected();
        if (numSelected !== this.prevNumSelected) {
            this.numSelectedChange.emit(numSelected);
            this.prevNumSelected = numSelected;
        }
    };
    FuelFilterListComponent.prototype.getNumSelected = function () {
        if (!this.filterComponents) {
            return 0;
        }
        var selected = this.filterComponents.filter(function (c) { return c.filter.enabled; }).length;
        this._cdRef.detectChanges();
        return selected;
    };
    Object.defineProperty(FuelFilterListComponent.prototype, "fuel100LLFilter", {
        get: function () {
            return this.query.getFilter(FilterKeys.FuelFilter)
                .find(function (f) { return f.fuelType === FuelType._100LL; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FuelFilterListComponent.prototype, "fuelJetAFilter", {
        get: function () {
            return this.query.getFilter(FilterKeys.FuelFilter)
                .find(function (f) { return f.fuelType === FuelType.JetA; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FuelFilterListComponent.prototype, "fuelMOGASFilter", {
        get: function () {
            return this.query.getFilter(FilterKeys.FuelFilter)
                .find(function (f) { return f.fuelType === FuelType.MOGAS; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FuelFilterListComponent.prototype, "fuelUL94Filter", {
        get: function () {
            return this.query.getFilter(FilterKeys.FuelFilter)
                .find(function (f) { return f.fuelType === FuelType.UL94; });
        },
        enumerable: true,
        configurable: true
    });
    FuelFilterListComponent.prototype.fuelChange = function (e, fuelType) {
        this._globalSettingsService.changeFuelType(fuelType);
        if (fuelType === '100LL' && e) {
            this.fuelJetAFilter.enabled = false;
            this.fuelMOGASFilter.enabled = false;
            this.fuelUL94Filter.enabled = false;
        }
        if (fuelType === 'JetA' && e) {
            this.fuel100LLFilter.enabled = false;
            this.fuelMOGASFilter.enabled = false;
            this.fuelUL94Filter.enabled = false;
        }
        if (fuelType === 'MOGAS' && e) {
            this.fuel100LLFilter.enabled = false;
            this.fuelJetAFilter.enabled = false;
            this.fuelUL94Filter.enabled = false;
        }
        if (fuelType === 'UL94' && e) {
            this.fuel100LLFilter.enabled = false;
            this.fuelMOGASFilter.enabled = false;
            this.fuelJetAFilter.enabled = false;
        }
        // this.filtersChange.emit();
        // this._cdRef.detectChanges();
        /* console.log('100LL: ', this.fuel100LLFilter.enabled);
        console.log('JetA: ', this.fuelJetAFilter.enabled);
        console.log('MOGAS: ', this.fuelMOGASFilter.enabled);
        console.log('UL94: ', this.fuelUL94Filter.enabled); */
    };
    return FuelFilterListComponent;
}());
export { FuelFilterListComponent };
